document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[name="executor_search"]');

  if (form) {
    const inputNameField = document.querySelector('#executor_search_name');
    const inputNumberField = document.querySelector('#executor_search_number');
    const inputDistrictField = document.querySelector(
      '#executor_search_district'
    );
    const select = document.querySelector('.select-selected');
    const error = document.querySelector('.executor-error-message');

    select.innerHTML =
      localStorage.getItem('selectedValue') ?? 'Podle jména A-Z';

    const observer = new MutationObserver(() => {
      const orderValue = document.getElementById('executor_search_orderValue');
      console.log(select.innerHTML);
      if (select.innerHTML === 'Podle jména Z-A') {
        orderValue.value = 8;
      } else {
        orderValue.value = 7;
      }
      localStorage.setItem('selectedValue', select.innerHTML);
      form.submit();
    });

    const searchButton = document.getElementById('executorSendBtn');
    searchButton.addEventListener('click', function (event) {
      let executorSearchOffset = document.getElementById(
        'executor_search_offset'
      );
      executorSearchOffset.value = 0;
    });

    form.addEventListener('submit', (event) => {
      if (inputNameField.value.length < 3 && inputNameField.value.length > 0) {
        if (
          inputNumberField.value.length < 1 &&
          inputDistrictField.value.length < 1
        ) {
          event.preventDefault();
          error.style.display = 'block';
        } else {
          error.style.display = 'none';
        }
      } else {
        error.style.display = 'none';
      }
    });

    observer.observe(select, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }
});
